import React, { useEffect, useState } from 'react'
import { Box, Grid, ListItem, makeStyles, Typography, useTheme } from "@material-ui/core"
import Checkbox from '../checkbox'
import ClusterFilter from './ClusterFilter'
import { useDataProvider, Loading, useTranslate } from 'react-admin'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import { RateItem } from '../dashboard/ReportDashboard'
import MessageChart from './MessageChart'
import ic_export from '../assets/icons/ic_export.png'
import { baseAuthUrl } from '../authProvider'
import moment from 'moment-timezone';
import LoadingPage from '../common/loading-page'
import { formatperent } from '../dashboard/Dashboard'
const useStyles = makeStyles(theme => ({
    TitleUsage: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 14,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 2.14,
        letterSpacing: '0.15px',
        color: '#4f5064',

    },
    serverTime: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: 10,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.2px',
        color: '#88898c',
        marginBottom: 8
    },
    timeValue: {
        fontFamily: 'UniviaPro',
        fontSize: 13,
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    filter: {
        fontFamily: 'UniviaPro',
        fontSize: 13,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    export: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: 10,
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        marginRight: 8
    }

}));

const convertTimeSpan = (diff) => {
    var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    diff -= days * (1000 * 60 * 60 * 24);
    days = days < 1 ? '' : days + ` ${days > 1 ? 'days' : 'day'}`

    var hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * (1000 * 60 * 60);
    hours = hours < 1 ? '' : hours + ` ${hours > 1 ? 'hours' : 'hour'}`

    var mins = Math.floor(diff / (1000 * 60));
    diff -= mins * (1000 * 60);
    mins = mins < 1 ? '' : mins + ` ${mins > 1 ? 'mins' : 'min'}`

    var seconds = Math.floor(diff / (1000));
    diff -= seconds * (1000);
    seconds = seconds + ` ${seconds > 1 ? 'seconds' : 'second'}`
    return {
        days,
        hours,
        mins,
        seconds
    }
}
const ReportSession = (isHidden) => {
    const theme = useTheme()
    const classes = useStyles()
    const [entities, setEntities] = useState([])
    const [loading, setLoading] = useState(false)
    const [tvloading, setTvLoading] = useState(false)
    const [languageLoading, setLanguageLoading] = useState(false)
    const [messageLoading, setMessageLoading] = useState(false)
    const [selectionLoading, setSelectionLoading] = useState(false)
    const [serverDowTimeLoading, setServerDowTimeLoading] = useState(false)
    const [timeViewLoading, setTimeViewLoading] = useState(false)

    const [tvUsages, setTvUsage] = useState()
    const [timeChannels, setTimeChannels] = useState([])
    const [exportLoading, setExportLoading] = useState(false)
    const [users, setUsers] = useState([])
    const [languages, setLanguages] = useState([])
    const [infopages, setInfopages] = useState([])
    const [timeServer, setTimeServer] = useState()
    const [openFilter, setOpenFilter] = useState(false)
    const [openFilterInfoPage, setOpenFilterInfoPage] = useState(false)
    const [clusters, setClusters] = useState([])
    const translate = useTranslate()
    const dataProvider = useDataProvider()




    const formatperenttoarray = (array) => {
        var tempdiff = 0
        var total = 0
        array.forEach(item => total += item[1])
        array.map(item => {
            item[1] = (item[1] / total) * 100
            tempdiff += Math.floor(item[1])
            return item
        })
        var diff = 100 - tempdiff
        array.sort(function (a, b) { return (b[1] - Math.floor(b[1])) - (a[1] - Math.floor(a[1])) })
        return array.map(item => {
            if (diff > 0) {
                item[1] = Math.floor(item[1]) + 1
                diff--
            }
            else
                item[1] = Math.floor(item[1])
            return item
        })
    }

    const getCluster = () => {
        setLoading(true)
        dataProvider('GET_ONE', "users/getclusterfilter", { id: JSON.parse(localStorage.getItem('userData')).user.id },
        )
            .then(({ data }) => {

                setEntities(data.levels);

                setLoading(false);
            })
            .catch(error => {
                // setError(error);
                setLoading(false);
            });
    }


    const getLanguage = (clusterIds) => {
        setLanguageLoading(true)
        dataProvider('GET_LIST', "info-language-count", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            let total = 0
            let temps = []
            data.forEach(item => {
                temps.push([item.name, item.count])
            })

            //setLanguageTotal(total)
            setLanguages(formatperenttoarray(temps))
            setLanguageLoading(false)
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
            setLanguageLoading(false)
        });
    }

    const getTvUsage = (clusterIds) => {
        setTvLoading(true)
        dataProvider('GET_LIST', "usage-data/get-tv-summarize", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            if (data.length === 0)
                setTvUsage(null)
            else {
                let arrayData = data.detail
                arrayData.splice(0, 1)
                setTvUsage(formatperent(arrayData))

            }
            setTvLoading(false);
        }).catch(error => {
            setTvUsage(null)
            // setError(error);
            setTvLoading(false);
        });
    }

    const getMessageAlarm = (clusterIds) => {
        setMessageLoading(true)
        dataProvider('GET_LIST', "usage-data/get-message-alarm", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            setUsers(data)
            // setLoading(false);
            setMessageLoading(false)
        }).catch(error => {
            console.log(error)
            setMessageLoading(false)
            // setError(error);
            // setLoading(false);
        });
    }

    const getSelectionMenu = (clusterIds) => {
        setSelectionLoading(true)
        dataProvider('GET_LIST', "usage-data/get-menu-selection", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            data.map(item => {
                item.checked = true
                if (item.menu.length > 0)
                    item.menu = formatperenttoarray(item.menu)
                return item
            })
            setInfopages(data)
            setSelectionLoading(false)
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            setSelectionLoading(false)
            // setError(error);
            // setLoading(false);
        });
    }

    const getTimeServer = () => {
        setServerDowTimeLoading(true)
        dataProvider('GET_LIST', "usage-data/get-server-downup-time", {
            filter: {
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {
            if (data.length > 0)
                setTimeServer({
                    upTime: convertTimeSpan(data[1]),
                    downTime: convertTimeSpan(data[0] - data[1])
                })
            // setLoading(false);
            setServerDowTimeLoading(false)
        }).catch(error => {
            console.log(error)
            // setError(error);
            // setLoading(false);
            setServerDowTimeLoading(false)
        });
    }

    const getTimeView = (clusterIds) => {
        setTimeViewLoading(true)
        dataProvider('GET_LIST', "usage-data/get-time-view-ic", {
            filter: {
                cluster: clusterIds,
                userID: JSON.parse(localStorage.getItem('userData')).user.id
            },
            pagination: {},
            sort: {},
        }).then(({ data }) => {

            // var total = 0
            // data.forEach(item => {
            //     total += item[1]
            // })
            // let temps = []
            // data.forEach(item => {
            //     temps.push({
            //         value: Math.round(item[1] / total * 100) || 0,
            //         name: item[0]
            //     })
            // })
            var temps = formatperenttoarray(data)
            setTimeChannels(temps)
            setTimeViewLoading(false)
            // setLoading(false);
        }).catch(error => {
            console.log(error)
            setTimeViewLoading(false)
            // setError(error);
            // setLoading(false);
        });
    }

    useEffect(() => {
        getCluster()
    }, [])

    const onChangeCheckBox = (index) => {
        let temps = infopages.slice()
        temps[index].checked = temps[index].checked !== undefined ? !temps[index].checked : true
        setInfopages(temps)
    }

    const handleExport = () => {
        setExportLoading(true)
        let clusterIds = []
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    cluster.checked && clusterIds.push(cluster.id)
                })
            })
        })
        const queryOptions = {
            cluster: clusterIds,
            infopagesId: infopages.filter(item => item.checked).map(item => item.id),
            section: ["Server Up-Time", "Server Down-Time", "TV Usage", "Language selection", "Time Channel", "Messages/Alarms", "Info Page"]
        };
        const whereConditions = encodeURI(JSON.stringify(queryOptions));
        var options = { method: 'GET' }
        options.headers = new Headers({ Accept: 'application/json' });
        options.headers.set('token', localStorage.getItem('token'));
        return fetch(`${baseAuthUrl}/render-engine?where=${whereConditions}`, options)
            .then(response => {
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Report_${moment(new Date()).format('YYYYMMDD')}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                setExportLoading(false)
            }).catch(e => {
                setExportLoading(false)
            })

    }

    useEffect(() => {
        let clusterIds = []
        let clusters = []
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    clusters.push(cluster)
                    cluster.checked && clusterIds.push(cluster.id)
                })
            })
        })
        setClusters(clusters)
        getTvUsage(clusterIds)
        getTimeView(clusterIds)
        getLanguage(clusterIds)
        getMessageAlarm(clusterIds)
        getSelectionMenu(clusterIds)
        getTimeServer()
    }, [])

    useEffect(() => {
        let clusterIds = []
        let clusters = []
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    clusters.push(cluster)
                    cluster.checked && clusterIds.push(cluster.id)
                })
            })
        })
        setClusters(clusters)
    }, [entities])

    if (loading || tvloading || languageLoading || messageLoading || timeViewLoading || serverDowTimeLoading || selectionLoading) return <Loading />
    return (
        <Box width='100%' py={5} bgcolor={theme.palette.background.default}>
            <LoadingPage show={exportLoading} />
            <Box hidden={isHidden.permissions}>
                <Box position='absolute' display='flex' right={30} top={20} color='white' style={{ cursor: 'pointer' }} alignItems='center' onClick={handleExport}>
                    <Typography className={classes.export}>{translate(`pos.usageData.export`)}</Typography>
                    <img src={ic_export} width={24} height={24}></img>
                </Box>
            </Box>
            <Box width='100%' display='flex' alignItems='center' height={80} bgcolor='rgba(255,255,255,0.7)'>
                <Box display='flex' alignItems='center' height={80} flexGrow={1}>
                    <Box mx={5}>
                        <Box display='flex'>
                            <Box bgcolor='#bbd593' width={14} height={14} mr={1} borderRadius='50%'></Box>
                            <Typography className={classes.serverTime}>{translate(`pos.usageData.serverUptime`)}</Typography>
                        </Box>
                        <Typography className={classes.timeValue}>{!timeServer ? 'N/a' : `${timeServer.upTime.days} ${timeServer.upTime.hours} ${timeServer.upTime.mins} ${timeServer.upTime.seconds}`}</Typography>
                    </Box>
                    <Box mx={5}>
                        <Box display='flex'>
                            <Box bgcolor='red' width={14} height={14} mr={1} borderRadius='50%'></Box>
                            <Typography className={classes.serverTime}>{translate(`pos.usageData.serverDowntime`)}</Typography>
                        </Box>
                        <Typography className={classes.timeValue}>{!timeServer ? 'N/a' :
                            `${timeServer.downTime.days} ${timeServer.downTime.hours} ${timeServer.downTime.mins} ${timeServer.downTime.seconds}`}</Typography>
                    </Box>
                </Box>
                <Box width={500} display='flex' height='100%'>
                    <Box width='100%' position='relative'>
                        <Box width='100%' position='absolute' height='100%' top={25} right={0}>
                            <SelectBox
                                maxHeight={600}
                                label={'Filter'}
                                value={<Box display='flex'>
                                    <Typography className={classes.filter} style={{ marginRight: 100 }}>{translate(`pos.usageData.selectCluster`)}</Typography>
                                    <Typography className={classes.filter}>{`${clusters.filter(item => item.checked).length}/${clusters.length} clusters`}</Typography>
                                </Box>}
                                open={openFilter}
                                handleClick={() => setOpenFilter(!openFilter)}>
                                <ListItem>
                                    <ClusterFilter entities={entities} setEntities={setEntities} setOpenFilter={setOpenFilter} setInfopages={setInfopages}
                                        setLanguages={setLanguages} setTimeChannels={setTimeChannels} setTimeServer={setTimeServer}
                                        setTvUsage={setTvUsage} setTvLoading={setTvLoading} setUsers={setUsers} setClusters={setClusters}
                                    />
                                </ListItem>
                            </SelectBox>
                        </Box>
                    </Box>
                </Box>


            </Box>

            <Box bgcolor='rgba(255,255,255,0.7)' py={3} px={5} my={5} display='flex' alignItems='center'>
                <Box>
                    <Box flexGrow={1} ml="5px">
                        <Typography className={classes.TitleUsage}>
                            {translate(`pos.dashboard.usageData`)}
                        </Typography>
                    </Box>
                    <Grid container direction="row">
                        <RateItem rate={!tvUsages ? 0 : tvUsages.tvmode || 0} name={translate(`pos.dashboard.tv`)} color='#bbd593' firstItem={true}></RateItem>
                        <RateItem rate={!tvUsages ? 0 : tvUsages.offline || 0} name={translate(`pos.dashboard.offline`)} color='#eb5a4d'></RateItem>
                        <RateItem rate={!tvUsages ? 0 : tvUsages.menumode || 0} name={translate(`pos.dashboard.menu`)} color='#6cb5b8'></RateItem>
                        <RateItem rate={!tvUsages ? 0 : tvUsages.infochannel || 0} name={translate(`pos.dashboard.infoChannel`)} color='#b21280' lastItem={true}></RateItem>
                    </Grid>
                </Box>

            </Box>

            <Box bgcolor='rgba(255,255,255,0.7)' py={3} px={5} my={5} display='flex' alignItems='center'>
                {languages.length > 0 ? (
                    <Box>
                        <Box flexGrow={1} ml="5px">
                            <Typography className={classes.TitleUsage}>
                                {translate(`pos.usageData.languageSelection`)}
                            </Typography>
                        </Box>
                        <Grid container direction="row">
                            {
                                languages.map((item, index) => (
                                    <RateItem key={'language_' + index} rate={item[1]} name={item[0]} color={'#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6)} firstItem={true}></RateItem>
                                ))
                            }

                        </Grid>
                    </Box>
                ) : <Box display='flex' alignItems='center'>
                        <Typography variant='h5'>{translate(`pos.usageData.noData`)}</Typography>
                    </Box>}

            </Box>

            <Box bgcolor='rgba(255,255,255,0.7)' py={3} px={5} my={5} display='flex' alignItems='center'>
                {timeChannels.length > 0 ? (
                    <Box>
                        <Box flexGrow={1} ml="5px">
                            <Typography className={classes.TitleUsage}>
                                {translate(`pos.usageData.timeChannel`)}
                            </Typography>
                        </Box>
                        <Grid container direction="row">
                            {
                                timeChannels.map((item, index) => (
                                    <RateItem key={'TimeChannel_' + index} rate={item[1]} name={item[0]} color={'#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6)} firstItem={true}></RateItem>
                                ))
                            }

                        </Grid>
                    </Box>
                ) : <Box display='flex' alignItems='center'>
                        <Typography variant='h5'>{translate(`pos.usageData.noData`)}</Typography>
                    </Box>}

            </Box>

            <Box bgcolor='rgba(255,255,255,0.7)' py={3} px={5} my={5} display='flex' alignItems='center'>
                {users.length > 0 ? (
                    <Box width='100%'>
                        <Box flexGrow={1} ml="5px" mb={3}>
                            <Typography className={classes.TitleUsage}>
                                {translate(`pos.usageData.messageAlarm`)}
                            </Typography>
                        </Box>
                        <MessageChart data={users}></MessageChart>
                    </Box>
                ) : <Box display='flex' alignItems='center'>
                        <Typography variant='h5'>{translate(`pos.usageData.noData`)}</Typography>
                    </Box>}
            </Box>

            <Box bgcolor='rgba(255,255,255,0.7)' display='flex'>
                <Box width='100%'>
                    <Box display='flex' width='100%' justifyContent='space-between'>
                        <Box mt={3} ml={5}>
                            <Typography className={classes.TitleUsage}>
                                {translate(`pos.usageData.nodeSelection`)}
                            </Typography>
                        </Box>

                        <Box position='relative' width={500}>
                            <Box width='100%' position='absolute' height='100%' top={0} right={0}>
                                <SelectBox
                                    maxHeight={600}
                                    label={'Filter'}
                                    value={<Box display='flex'>
                                        <Typography className={classes.filter} style={{ marginRight: 100 }}>{translate(`pos.usageData.selectInfoPage`)}</Typography>
                                        <Typography className={classes.filter}>{`${infopages.filter(item => item.checked).length}/${infopages.length} infopages`}</Typography>
                                    </Box>}
                                    open={openFilterInfoPage}
                                    handleClick={() => setOpenFilterInfoPage(!openFilterInfoPage)}>
                                    {
                                        infopages.map((data, index) => (
                                            <ListItem onClick={() => onChangeCheckBox(index)} key={'item-' + index} style={{ padding: '8px' }} button className={classes.boxBoder}>
                                                <Checkbox color='primary' checked={data.checked === undefined ? false : data.checked}></Checkbox>
                                                <Typography className={classes.TextValue}>{data.name}</Typography>
                                            </ListItem>
                                        ))
                                    }
                                </SelectBox>
                            </Box>

                        </Box>
                    </Box>
                    {
                        infopages.filter(item => item.checked).map((item, index) => (
                            <Box key={'infopage_' + index} bgcolor='rgba(255,255,255,0.7)' py={3} px={5} my={5} mx={5} display='flex' alignItems='center'>

                                <Box>
                                    <Box flexGrow={1} ml="5px">
                                        <Typography className={classes.TitleUsage}>
                                            {item.name}
                                        </Typography>
                                    </Box>
                                    {item.menu.length > 0 ? (
                                        <Grid container direction="row">
                                            {
                                                item.menu.map((item, index) => (
                                                    <RateItem key={'menu' + index} rate={item[1]} name={item[0]} color={'#' + (0x1000000 + (Math.random()) * 0xffffff).toString(16).substr(1, 6)} firstItem={true}></RateItem>
                                                ))
                                            }

                                        </Grid>
                                    ) : <Box display='flex' alignItems='center' ml="5px">
                                            <Typography variant='body1'>{translate(`pos.usageData.noData`)}</Typography>
                                        </Box>}
                                </Box>


                            </Box>
                        ))
                    }

                </Box>

            </Box>

        </Box>
    )
}
export default ReportSession